import {
    UPDATEKYCLABELPARTNER_SUCCESS,
    UPDATEKYCLABELPARTNER_FAILED,
    RESET_UPDATEKYCLABELPARTNER,
    LOADING_UPDATEKYCLABELPARTNER,
    NETWORK_ERROR_UPDATEKYCLABELPARTNER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UPDATEKYCLABELPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case UPDATEKYCLABELPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case UPDATEKYCLABELPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_UPDATEKYCLABELPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_UPDATEKYCLABELPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
